import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { ILoginWizard } from './login.wizard.service';
import { AuthService } from '../../auth.service';
import { Center } from '../../../model/center';
import { SectorFilter } from '../../../model/sector-filter';
import { ServiceService } from '../../service.service';
import { MessageServerService } from '../../hub-services/message-server/message-server.service';
import { CompanyFilter } from '../../../model/company-filter';

export class LoginDefaultWizardService implements ILoginWizard {

  constructor(private router: Router
    , private serviceService: ServiceService
    , private messageServerService: MessageServerService
    , private authService: AuthService) {
    this.authService.logOut();
  }

  returnUrl: string;

  async login(userName: string, userPassword: string, returnUrl: string): Promise<void> {

    if (await this.authService.login(userName, userPassword)) {
      this.returnUrl = returnUrl;
      this.router.navigate(['/login-sector']);
    }
  }

  getAllCompanies(): CompanyFilter[] {
    return this.authService.getLoginUser().Companies;
  }

  getAllCenters(): Center[] {
    return this.authService.getLoginUser().Centers;
  }

  async setSectorCenterAndCompanies(
        sector: SectorFilter,
        center: Center,
        companies: CompanyFilter[]) {

    const services = await this.serviceService.getServicesFilter(sector ? sector.Id : null);
    this.authService.setSectorCenterCompaniesAndServices(sector, center, companies, services);
    this.messageServerService.joinGroups();

    if ( this.authService.getPhysicianId() ) {
      this.messageServerService.joinPhysicianGroup();
    }

    // if ( this.returnUrl ) {
    //   this.router.navigateByUrl(this.returnUrl);
    // } else {
    //   const url = this.authService.getInitUrl();
       this.router.navigate(['home']);
    // }
  }

  // busco los sectores del centro seleccionado
  getSectors(centerId: number): SectorFilter[] {

    const sectors: SectorFilter[] = [];
    if (this.authService.getLoginUser().Sectors != null) {
      this.authService.getLoginUser().Sectors.forEach((sector) => {
        if (sector.CenterId === centerId) {
          sectors.push(sector);
        }
      });
    }

    return sectors;
  }
}
